import React from 'react'
import {Flex} from '@chakra-ui/react'
import TopBar from './TopBar'
import Watermark from './Watermark'

const Layout = ({children}) => {
    return (
        <Flex direction="column" w="100%" h="100vh" overflow="hidden">
            <TopBar/>

            <Flex
                direction="column"
                w="100%"
                grow="1"
                overflow="auto"
                p={{base: '2', md: '4'}}
            >
                {children}
            </Flex>
            <Watermark/>
        </Flex>
    )
}

export default Layout
